import { Spinner } from 'components/core';
import React, { PropsWithChildren, ReactElement } from 'react';
import { useIsAuthenticated } from 'store/user';

/**
 * Holds the view back until the current user's profile (permissions, personal
 * data) is in the user store. The project is already guaranteed by
 * `WithSelectProject`, but Auth0 reports "authenticated" slightly before the
 * profile is fetched (e.g. when the session is restored on tab resume).
 */
export function WithFetcherReady({
  children,
}: PropsWithChildren<{}>): ReactElement {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return <Spinner reason='WithFetcherReady: user profile not loaded yet' />;
  }

  return <>{children}</>;
}
